export function getStripeCustomerLink(stripeId: string) {
  return `https://dashboard.stripe.com/customers/${stripeId}`
}

export function getAuth0UserLink(userId: string) {
  return `https://manage.auth0.com/dashboard/eu/hivemq-cloud/users/${userId}`
}
